import { gql } from '@apollo/client'

export const PICOS_PRIORITY_OVERVIEW_FRAGMENT = gql`
  fragment PicOSPriorityOverview on PicOSPriority {
    id
    priority
    name
    activeDaysRemaining
    description
    mandateType
    executionTarget
    displayElements
    startDate
    endDate
    image {
      id
      url
    }
  }
`
